export const modalForms = {
  methods: {
    openFormPropose() {
      this.$store.commit("modalData/UPDATE_MODALSTATE", {
        openModal: true,
        component: "FormProposal",
        title: "Quero ser Contactado",
        slotWrapClass: "form",
        // content: content
      });
      document.body.classList.add("isActive");
    },
    openFormMTD() {
      this.$store.commit("modalData/UPDATE_MODALSTATE", {
        openModal: true,
        component: "FormTestDrive",
        title: "Marcar Test-Drive",
        slotWrapClass: "form",
      });
      document.body.classList.add("isActive");
    },
    openFormEmail() {
      this.$store.commit("modalData/UPDATE_MODALSTATE", {
        openModal: true,
        component: "FormCfgEmail",
        title: "Enviar configuração por email",
        slotWrapClass: "form",
      });
      document.body.classList.add("isActive");
    },
  },
};
